import React, { useEffect, useState, useMemo } from "react";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { debounce } from "lodash";
import layoutConf from "../../config/layoutConf";

import authProfileState from "../../states/authProfileState";
import notificationState from "../../states/notificationState";
import defineConf from "../../config/defineConf";
import AccessControl from "../functional/AccessControl";

import { useTranslation } from "react-i18next";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getSchema from "../../lib/api/getSchema";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteSingleRecordButton from "../input/DeleteSingleRecordButton";

function TkPartnerPriceAgreementFiles(props) {
    const { onSelectMst } = props;

    const id = "TkPartnerPriceAgreementFile";
    const table = "TkPartnerPriceAgreementFile";
    const view = "TkVwPartnerPriceAgreementFile";

    const { t } = useTranslation();

    const [tkPartnerPriceAgreementFileSchema, setTkPartnerPriceAgreementFileSchema] = useState();
    const [tkPartnerPriceAgreementFileGrid, setTkPartnerPriceAgreementFileGrid] = useState();
    const [tkPartnerPriceAgreementFileDataIsEmpty, setTkPartnerPriceAgreementFileDataIsEmpty] = useState();
    const [tkPartnerPriceAgreementFileApi, setTkPartnerPriceAgreementFileApi] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {
        let mounted = true;

        (async () => {
            let schema = await getSchema(table);

            setTkPartnerPriceAgreementFileSchema(schema);

            if (mounted) {
                setTkPartnerPriceAgreementFileSchema(schema);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (tkPartnerPriceAgreementFileApi) {
            tkPartnerPriceAgreementFileApi.refresh();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onSelectMst]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (msg) => {
        notifyFailure(msg);
    };

    return (
        <BasicCrudScreenType
            id={id}
            headerTitle={t("term.partnerPriceAgreementFile")}
            view={view}
            onInitialized={(grid) => {
                grid.selectionMode = "Row";
                setTkPartnerPriceAgreementFileGrid(grid);
            }}
            onApiInitialized={(api) => {
                setTkPartnerPriceAgreementFileApi(api);
            }}
            onLoadData={(data) => {
                setTkPartnerPriceAgreementFileDataIsEmpty(data.length < 1 ? true : false);
            }}
            onModifyViewUrl={(url) =>
                `${url}/${onSelectMst.agreementType}/${onSelectMst.agreementId}/${onSelectMst.processCode}`
            }
            noCreate
            noEdit
            noDelete
            noExcel
            noFilter
            noPagination
            onAppendButtonInFrontOfSearch={() => (
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tkPartnerPriceAgreementFileSchema && tkPartnerPriceAgreementFileSchema.name}
                        accessMethod="POST"
                    >
                        <CreateRecordButton
                            id={id}
                            schema={tkPartnerPriceAgreementFileSchema}
                            refresh={tkPartnerPriceAgreementFileApi}
                            setInitialDataCallback={(formData) => {
                                formData.agreementType = onSelectMst.agreementType;
                                formData.agreementId = onSelectMst.agreementId;
                                formData.processCode = onSelectMst.processCode;
                            }}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkPartnerPriceAgreementFileSchema && tkPartnerPriceAgreementFileSchema.name}
                        accessMethod={
                            tkPartnerPriceAgreementFileSchema &&
                            (tkPartnerPriceAgreementFileSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <UpdateRecordButton
                            id={id}
                            schema={tkPartnerPriceAgreementFileSchema}
                            grid={tkPartnerPriceAgreementFileGrid}
                            refresh={tkPartnerPriceAgreementFileApi}
                            disabled={tkPartnerPriceAgreementFileDataIsEmpty}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tkPartnerPriceAgreementFileSchema && tkPartnerPriceAgreementFileSchema.name}
                        accessMethod="DELETE"
                    >
                        <DeleteSingleRecordButton
                            id={id}
                            schema={tkPartnerPriceAgreementFileSchema}
                            grid={tkPartnerPriceAgreementFileGrid}
                            refresh={tkPartnerPriceAgreementFileApi}
                            makeItemName={(row) => {
                                return ` - ${t("columnName.partnerPriceAgreementFileId")}: ${
                                    row.partnerPriceAgreementFileId
                                }`;
                            }}
                            color="secondary"
                            disabled={tkPartnerPriceAgreementFileDataIsEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            )}
        />
    );
}

export default TkPartnerPriceAgreementFiles;
